export const CELIA_BOT_URL = "https://t.me/CeliaCasaDelPuebloBot?start=webapp";
